import { Component, OnInit, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { EmployeeService } from '../employee.service';
import { NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { NewUserComponent } from '../new-user/new-user.component';
import { EditUserComponent } from '../edit-user/edit-user.component';

@Component({
  selector: 'ngx-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  @Input() stationId: string;
  source: LocalDataSource;
  loading: boolean = false;

  settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<i class="fa fa-edit" title="YourAction"></i>',
        },
        {
          name: 'delete',
          title: '<i class="far fa-trash-alt" title="delete"></i>',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      id: {
        title: 'Nombre',
        filter: true,
      },
      name: {
        title: 'Email',
        filter: true,
      },
      role: {
        title: 'Rol',
        filter: true,
      },
      activities: {
        title: 'Puesto',
        filter: false,
      },
    },
  };

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
  ) { }

  ngOnInit() {
    this.getEmployees();
  }

  async getEmployees() {
    this.loading = true;
    const [error, { data: result }] = await this.employeeService.getEmployees(this.stationId);
    if (error) return error;

    this.source = new LocalDataSource(result);
    this.loading = false;
  }

  openNewEmployee() {
    this.dialogService.open(NewUserComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteEmployee(event.data.id);
    } else if (event.action === 'edit') {
      this.editEmployee(event.data);
    }
  }

  async editEmployee(employee) {
    this.dialogService.open(EditUserComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        employee: employee,
      },
    }).onClose.subscribe(employeeUpdated => employeeUpdated ? this.getEmployees() : null);
  }

  async deleteEmployee(id) {
    Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Borrar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.employeeService.deleteEmployee(this.stationId, id);
        // tslint:disable-next-line: max-line-length
        if (error) return this.alert('Ocurrio un error al intentar borrar el elemento, intenta más tarde por favor', 'error');

        this.alert('Empleado borrado con éxito');
        this.getEmployees();
      }
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
